<template>
  <div>
    <salesman v-if="userInfo.userType=='4'"></salesman>
    <channel v-else></channel>
  </div>
</template>

<script>
import channel from './channel';
import salesman from './salesman';
export default {
  components:{
    channel,
    salesman
  },

  data(){
    return {
      userInfo:JSON.parse(localStorage.getItem('userInfo'))
    }
  }
};
</script>